// // 基准大小
// const baseSize = 16

// // 设置 rem 函数
// function setRem() {
//   // 当前页面宽度相对于 1920 宽的缩放比例，可根据自己需要修改
//   const scale = document.documentElement.clientWidth / 2000
  
//   // 设置页面根节点字体大小（最高为16px，可根据实际需求调整）
//   const fontSize = (baseSize * Math.min(scale, 2))
  
//   document.documentElement.style.fontSize = fontSize + 'px'
// }

// // 初始化
// setRem()

// // 改变窗口大小时重新设置 rem
// window.onresize = function() {
//   setRem()
// }
(function (doc, win) {
  const docEl = doc.documentElement
  const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  
  const recalc = function () {
    const clientWidth = docEl.clientWidth
    if (!clientWidth) return
    if (isMobile) {
      // 移动端适配 - 基于 750px 设计稿
      if (clientWidth >= 750) {
        docEl.style.fontSize = '16px'
      } else {
        docEl.style.fontSize = 16 * (clientWidth / 750) + 'px'
      }
    } else {
      // PC端适配 - 基于 1920px 设计稿
      if (clientWidth >= 1920) {
        docEl.style.fontSize = '16'
      } else {
        docEl.style.fontSize = 16 * (clientWidth / 1920) + 'px'
      }
    }
  }
  
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window)